import request from "@/utils/request";
import config from "@/utils/config";
import {
	handleUrlEncode
} from "@/utils/urlutil"
import {
	getForumCategoryList
} from "@/api/ultrasonic"

/**
 * 后台分页获取问题集合
 * @param {Object} param
 */
export function getProblemList(param) {
	let url = config.API_ADMIN + "/Api/V1/AdminProblem/List?";
	url = handleUrlEncode(url, param)
	return request({
		url: url,
		method: "get",
	});
}

/**
 * 后台问题删除或者恢复
 * @param {Object} param
 */
export function deleteProblemOrBack(param) {
	return request({
		url: config.API_ADMIN + "/Api/V1/AdminProblem/DeleteOrBack",
		method: "delete",
		params: param
	});
}

/**
 * 后台问题信息更新
 * @param {Object} data
 */
export function updateProblem(data) {
	return request({
		url: config.API_ADMIN + "/Api/V1/AdminProblem/Update",
		method: "post",
		data
	});
}

/**
 * fixme
 * 获取往期回顾所有类型
 */
export function getCategoryList() {
	return getForumCategoryList()
}

/**
 * 后台问题添加
 * @data {Object} data
 */
export function addProblem(data){
	return request({
		url: config.API_ADMIN + "/Api/V1/AdminProblem/Add",
		method: "post",
		data
	});
}

/**
 * 后台获问答模块配置信息
 */
export function getProblemConfig(){
	return request({
		url: config.API_ADMIN + "/Api/V1/AdminProblem/ProblemConfig",
		method: "get",
	});
}

/**
 * 后台问答模块配置信息更新
 * @param {Object} data
 */
export function updateProblemConfig(data){
	return request({
		url: config.API_ADMIN + "/Api/V1/AdminProblem/ProblemConfig/Update",
		method: "post",
		data
	});
}